
export const shortenString = (str: string, size: number) => str.length < size ?
  str : str.substr(0,size).trim() + '...'
